export const range = (start: number, end: number) => {
  const output: number[] = [];
  for (let i = start; i <= end; i++) {
    output.push(i);
  }
  return output;
};
